module.exports = __webpack_public_path__ + "static/media/art_blank_avatar_2x.16d85678.png";